import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import { logout } from '../../store/slices/authSlice';
import { useDispatch } from 'react-redux';
import { getPersistedSessionId } from '../../utils/auth';
import { motion } from 'framer-motion';
import { FaCopyright } from 'react-icons/fa'; 

const Layout = () => {
  const dispatch = useDispatch();
  
  const handleLogout = () => {
    const sessionId = getPersistedSessionId();
    dispatch(logout(sessionId));
  };

  return (
    // h-screen மற்றும் overflow-hidden மூலம் முழு ஸ்கிரீன் அளவை லாக் செய்கிறோம்
    <div className="h-screen w-full flex flex-col overflow-hidden bg-gray-50">
      
      {/* --- HEADER (நிலையானது) --- */}
      <div className="flex-shrink-0 z-50 shadow-md">
        <Navbar onLogout={handleLogout} />
      </div>

      {/* --- BODY (இது மட்டுமே ஸ்க்ரோல் ஆகும்) --- */}
      {/* flex-1 மற்றும் overflow-y-auto கொடுக்கப்பட்டுள்ளதால் நடுப்பகுதி மட்டும் ஸ்க்ரோல் ஆகும் */}
      <main className="flex-1 overflow-y-auto w-full relative">
        <Outlet />
      </main>

      {/* --- FOOTER (நிலையானது) --- */}
      <footer 
        style={{ background: 'linear-gradient(135deg, #7f083c 0%, #9a0a4a 100%)' }}
        className="flex-shrink-0 w-full py-2 flex items-center justify-center z-10"
      >
        <motion.div 
          className="flex items-center gap-2 text-white/90 text-xs md:text-sm tracking-wide"
          whileHover={{ scale: 1.02 }}
        >
          <FaCopyright className="text-[1rem]" />
          <span>
            {new Date().getFullYear()}{" "}
            <motion.a 
              href="https://shepherdsindia.sbs/" 
              target="_blank" 
              rel="noreferrer"
              className="font-semibold text-white mx-1"
              style={{ textDecoration: 'none' }}
              whileHover={{ 
                color: '#00ffff',
                textShadow: '0 0 10px #00ffff'
              }}
            >
              shepherdsindia.sbs
            </motion.a>{" "}
            All Rights Reserved
          </span>
        </motion.div>
      </footer>

    </div>
  );
};

export default Layout;